var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlimAccountsFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.8838 20.8662L45.1338 32.1162C45.9213 32.9037 45.3638 34.25 44.25 34.25H43V41.75C43 42.7445 42.6049 43.6984 41.9017 44.4016C41.1984 45.1049 40.2446 45.5 39.25 45.5H38V36.75C38.0001 35.7935 37.6346 34.8731 36.9784 34.1772C36.3222 33.4812 35.4249 33.0623 34.47 33.0062L34.25 33H31.75C30.7554 33 29.8016 33.3951 29.0984 34.0983C28.3951 34.8016 28 35.7554 28 36.75V45.5H26.75C25.7554 45.5 24.8016 45.1049 24.0984 44.4016C23.3951 43.6984 23 42.7445 23 41.75V34.25H21.75C20.6375 34.25 20.0788 32.9037 20.8663 32.1162L32.1163 20.8662C32.3507 20.6319 32.6685 20.5002 33 20.5002C33.3315 20.5002 33.6493 20.6319 33.8838 20.8662ZM34.25 35.5C34.5815 35.5 34.8995 35.6317 35.1339 35.8661C35.3683 36.1005 35.5 36.4185 35.5 36.75V45.5H30.5V36.75C30.5 36.4438 30.6124 36.1483 30.8159 35.9195C31.0193 35.6907 31.2997 35.5445 31.6038 35.5087L31.75 35.5H34.25Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlimAccountsFeature);
export default __webpack_public_path__ + "static/media/unlim_accounts_feature.f2960a4665670952eaa02fc9415e89fa.svg";
export { ForwardRef as ReactComponent };